export default __webpack_public_path__ + "static/media/CaretDownBlue.25f3e2ea.svg";